import { render, staticRenderFns } from "./AppBookingTermsAcceptor.vue?vue&type=template&id=ef4a599e&"
import script from "./AppBookingTermsAcceptor.vue?vue&type=script&lang=js&"
export * from "./AppBookingTermsAcceptor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports